module.exports = __webpack_public_path__ + "images/groups.png?4f85b0d83f5c3df37dd841dad3acf21b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/groups.png
// module id = 362
// module chunks = 0